import type { FC } from 'react';
import React from 'react';
import type { TInputType } from '@alfa-bank/site-input/models';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';

import type { TFormBirthday } from './models';
import { DEFAULT_SEPARATOR } from './config';

/**
 * Инпут даты рождения
 * memo требуется для того чтоб избежать лишнего
 * ререндера при сабмите, при котором Final Form сбрасывает значения
 * meta.touched, из-за чего пропадают галочки напротив
 * корректно заполненных полей
 */
export const FormBirthday: FC<TFormBirthday> = React.memo(
    ({
        BirthdayField,
        Field,
        className,
        errorMessage,
        ageLimit,
        ageCeil,
        getCaption,
        isNextFocus = true,
        isError,
        isSuccess,
        hideStatusIcon,
        name,
        settings = {},
        validateBirthday,
        isRequired = true, // для обратной совместимости
    }) => {
        return (
            <Field
                data={settings}
                dispatchesFocus
                name={name}
                receivesFocus
                render={({ input, meta }) => {
                    const { name: inputName, type, value: inputValue, ...restInput } = input;
                    const { withAdditionalZero = true } = settings;

                    return (
                        <div className={className}>
                            <BirthdayField
                                {...restInput}
                                caption={getCaption(meta, settings.caption, inputValue)}
                                error={isError(meta, inputValue)}
                                forwardedRef={actions.getRef(meta)}
                                hideStatusIcon={hideStatusIcon}
                                name="passportBirthDateField"
                                onBlur={actions.onBlur(input)}
                                onCancel={actions.onCancel({ input, meta })}
                                onChange={value => {
                                    actions.onChange(input)(value);
                                    if (isNextFocus && !validateBirthday()(value))
                                        actions.onComplete({ input, meta });
                                }}
                                onFocus={actions.onFocus(input)}
                                placeholder={settings.placeholder}
                                separator={settings.separator || DEFAULT_SEPARATOR}
                                success={isSuccess(meta)}
                                type={type as TInputType}
                                value={inputValue}
                            />
                            <input
                                name={inputName}
                                type="hidden"
                                value={
                                    withAdditionalZero
                                        ? input.value
                                        : input.value.replace(/\b0/g, '')
                                }
                            />
                        </div>
                    );
                }}
                validate={validateBirthday(errorMessage, ageLimit, ageCeil, isRequired)}
            />
        );
    }
);
